<template>
    <div class="account">
        <vFlowNegativeWriteoffListComponent :postList="postList" v-if="flag"></vFlowNegativeWriteoffListComponent>
    </div>
</template>
<script>
import vFlowNegativeWriteoffListComponent from '../../listComponent/basicdata/flowSourceLists/flowNegativeWriteoffListComponent.vue';
export default {
    name: 'flowNegativeWriteoffList',
    components: {
        vFlowNegativeWriteoffListComponent
    },
    data() {
        return {
            postList: {
                searchBtn: true,
                downFileBtn: true,
                resetBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>